import { getStateNameFromAbbrev, getStateFipsFromName, statetoFips } from "./constants.js";

function isNumeric(value) {
  return /^-?\d+$/.test(value);
}

const initConfig = () => {
  const config = {};
  const defaultState = process.env.PSEO_APP_DEFAULT_STATE;
  if (defaultState.length === 2) {
    if (isNumeric(defaultState)) {
      // the state fips was passed
      config.defaultState = defaultState;
    } else {
      // a state 2 letter abbreviation was passed
      const stateName = getStateNameFromAbbrev(defaultState.toUpperCase());
      const stateFips = getStateFipsFromName(stateName);
      config.defaultState = stateFips;
    }
  } else {
    // the state name was passed
    config.defaultState = getStateFipsFromName(defaultState);
  }

  // config.universityDefault = {
  //   Alabama: "00105100",
  //   Arizona: "00108300",
  //   Colorado: "00137000",
  //   Connecticut: "00137800",
  //   Georgia: "00159800",
  //   Hawaii: "00161000",
  //   Indiana: "00180900",
  //   Iowa: "00189200",
  //   Louisiana: "00201000",
  //   Maine: "00205300",
  //   Massachusetts: "00222100",
  //   Montana: "00253600",
  //   Michigan: "00232500",
  //   Minnesota: "00396900",
  //   Missouri: "00251600",
  //   Ohio: "00309000",
  //   Oklahoma: "00318400",
  //   Oregon: "00322300",
  //   "New York": "00269000",
  //   Pennsylvania: "00332900",
  //   "South Carolina": "00344800",
  //   Texas: "00365800",
  //   Utah: "00367500",
  //   Virginia: "00374500",
  //   Wisconsin: "00389500",
  //   Wyoming: "00392800",
  // };

  // use the state margin as default
  config.universityDefault = statetoFips;

  config.degreeOrder = [
    "Certificate < 1 year",
    "Certificate 1-2 years",
    "Associates",
    "Certificate 2-4 years",
    "Baccalaureate",
    "Post-Bacc Certificate",
    "Masters",
    "Post-Masters Certificate",
    "Doctoral - Research/Scholarship",
    "Doctoral - Professional Practice",
    "All Degree Levels",
  ];

  return config;
};

export const config = initConfig();
export default config;
